import { SlotModel } from 'v2/types/SlotModel';

export const getSortedSlots = (slots: SlotModel[]) =>
  [...slots].sort((firstSlot, secondSlot) => {
    const { providerName: firstProviderName, title: firstSlotTitle } = firstSlot;
    const { providerName: secondProviderName, title: secondSlotTitle } = secondSlot;

    if (firstProviderName === secondProviderName) {
      if (firstSlotTitle === secondSlotTitle) {
        return 0;
      }
      return firstSlotTitle > secondSlotTitle ? 1 : -1;
    }

    return firstProviderName > secondProviderName ? 1 : -1;
  });
